import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { IState } from '../../../../store';
import { showLoginPopup } from '../../actions';
import { bannerCard, trackClickLogin } from '../../utils/tracking';
import { SignInButton } from './SignInButton';

export const SignInButtonContainer = connect(
  undefined,
  (dispatch: Dispatch<IState>) => ({
    onClick: bindActionCreators(showLoginPopup, dispatch),
  }),
  (stateProps, dispatchProps) => ({
    onClick() {
      trackClickLogin(bannerCard);
      dispatchProps.onClick();
    },
  }),
)(SignInButton);
